module.exports = __webpack_public_path__ + "static/Sohohouse-cb0e07b420a96f73ed52e151f09c8476.svg";